// @flow

import React from 'react'

import { MessageService } from '../../../services'
import { CCVideoUploader } from '../../UI'

type Props = {
  message: Object,
  s3Fields: Object,
  s3Options: Object,
  onErrorMessageUpdate: Function
}

const ERROR_MESSAGE = 'No video uploaded'

export class VideoMessage extends React.PureComponent<Props> {
  static defaultProps = {
    s3Fields: {},
    s3Options: {}
  }

  componentDidMount = () => {
    const { onErrorMessageUpdate, message } = this.props

    if (!message.video_url) onErrorMessageUpdate(ERROR_MESSAGE)
  }

  handleVideoUploaded = (url: string) => {
    const { message, onErrorMessageUpdate } = this.props

    MessageService.updateMessage(message.id, {
      ...message,
      video_url: url
    })

    !url ? onErrorMessageUpdate(ERROR_MESSAGE) : onErrorMessageUpdate('')
  }

  render () {
    const { message, s3Options, s3Fields } = this.props

    return (
      <CCVideoUploader
        onUpload={this.handleVideoUploaded}
        currentVideoUrl={message.video_url}
        s3PostBackUrl={s3Options.url}
        s3Fields={s3Fields}
      />
    )
  }
}
